import { cn } from '@/shared/lib/utils';

import { ModeSwitcher } from './ModeSwitcher';
import { SchemeSwitcher } from './SchemeSwitcher';

export interface ThemeSwitcherProps {
  /** Apply a card chrome (border + shadow + surface).  Defaults to true. */
  framed?: boolean;
  className?: string;
}

const SECTION_LABEL = 'text-[9px] font-bold uppercase tracking-[0.08em] text-phx-text-muted';

/**
 * Compact Phoenix theme switcher — composes the {@link SchemeSwitcher}
 * dropdown and the {@link ModeSwitcher} light/dark toggle.  Both pieces read &
 * write the document `data-phx-*` attributes via `usePhxTheme`, persisting the
 * selection in `localStorage`.
 */
export function ThemeSwitcher({ framed = true, className }: ThemeSwitcherProps) {
  return (
    <div
      className={cn(
        'phx-theme-switcher gap-phx-4 text-phx-md inline-flex flex-wrap items-center',
        framed &&
          'rounded-phx-md border-phx-border bg-phx-surface px-phx-4 py-phx-3 shadow-phx-sm border',
        className
      )}
    >
      <div className="gap-phx-2 flex items-center">
        <span className={SECTION_LABEL}>Theme</span>
        <SchemeSwitcher align="start" />
      </div>

      <span aria-hidden className="bg-phx-border h-5 w-px" />

      <div className="gap-phx-2 flex items-center">
        <span className={SECTION_LABEL}>Mode</span>
        <ModeSwitcher />
      </div>
    </div>
  );
}
